import { c } from 'react-compiler-runtime';
import { XIcon } from '@primer/octicons-react';
import { clsx } from 'clsx';
import { defaultTokenSize, tokenSizes } from './TokenBase.js';
import classes from './_RemoveTokenButton.module.css.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const getTokenButtonIconSize = size => parseInt(tokenSizes[size || defaultTokenSize], 10) * 0.75;
const RemoveTokenButton = t0 => {
  const $ = c(24);
  let ariaLabel;
  let borderOffset;
  let className;
  let isParentInteractive;
  let rest;
  let size;
  if ($[0] !== t0) {
    const {
      "aria-label": t1,
      isParentInteractive: t2,
      size: t3,
      className: t4,
      borderOffset: t5,
      as: _as,
      ...t6
    } = t0;
    ariaLabel = t1;
    isParentInteractive = t2;
    className = t4;
    rest = t6;
    size = t3 === undefined ? defaultTokenSize : t3;
    borderOffset = t5 === undefined ? 0 : t5;
    delete rest.children;
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = borderOffset;
    $[3] = className;
    $[4] = isParentInteractive;
    $[5] = rest;
    $[6] = size;
  } else {
    ariaLabel = $[1];
    borderOffset = $[2];
    className = $[3];
    isParentInteractive = $[4];
    rest = $[5];
    size = $[6];
  }
  const t1 = isParentInteractive ? "span" : "button";
  const t2 = isParentInteractive ? -1 : undefined;
  const t3 = !isParentInteractive ? "Remove token" : ariaLabel;
  let t4;
  if ($[7] !== className) {
    t4 = clsx(classes.TokenButton, className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `translate(${borderOffset}px, -${borderOffset}px)`;
  let t6;
  if ($[9] !== t5) {
    t6 = {
      transform: t5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== size) {
    t7 = getTokenButtonIconSize(size);
    $[11] = size;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = /*#__PURE__*/jsx(XIcon, {
      size: t7
    });
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== rest || $[16] !== size || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t6 || $[22] !== t8) {
    t9 = /*#__PURE__*/jsx(BoxWithFallback, {
      as: t1,
      tabIndex: t2,
      "aria-label": t3,
      "data-size": size,
      className: t4,
      style: t6,
      ...rest,
      children: t8
    });
    $[15] = rest;
    $[16] = size;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};

export { RemoveTokenButton as default };
